import { createFileRoute } from '@tanstack/react-router';

import { MessageSquare } from 'lucide-react';

import { MainPane } from '../components/MainPane';

export const Route = createFileRoute('/chats/')({
    component: ChatsIndex,
});

// Shown at the bare /chats path (no chat selected yet). The Chats sidebar is
// rendered by the parent layout (AppShell → Sidebar in "chats" mode); this just
// fills the main pane so it isn't blank until a chat is opened.
function ChatsIndex() {
    return (
        <MainPane>
            <div className="flex flex-1 flex-col items-center justify-center gap-3 text-center">
                <div className="grid h-12 w-12 place-items-center rounded-xl bg-bg-2 text-text-faint">
                    <MessageSquare size={22} />
                </div>
                <div className="text-[13px] font-medium text-text-dim">No chat selected</div>
                <div className="max-w-[260px] text-[12px] text-text-faint">
                    Pick a conversation from the sidebar, or start a new one with the + button.
                </div>
            </div>
        </MainPane>
    );
}
